import { render, staticRenderFns } from "./ui-create-url-tags.vue?vue&type=template&id=4afe5c7a&scoped=true&"
import script from "./ui-create-url-tags.vue?vue&type=script&lang=ts&"
export * from "./ui-create-url-tags.vue?vue&type=script&lang=ts&"
import style0 from "./ui-create-url-tags.vue?vue&type=style&index=0&id=4afe5c7a&lang=scss&scoped=true&"
import style1 from "./ui-create-url-tags.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe5c7a",
  null
  
)

export default component.exports